import VolumeLowIcon from '@atlaskit/icon/core/volume-low';
import * as React from 'react';

export function SvgVolume1() {
  return <VolumeLowIcon label="" testId="ads-refreshed-icon" />;
}
